import { render, staticRenderFns } from "./TagsManagement.vue?vue&type=template&id=2fd8dc10&"
import script from "./TagsManagement.vue?vue&type=script&lang=js&"
export * from "./TagsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports